import { Injectable } from '@angular/core';
import { Actions as EffectActions, createEffect, ofType } from '@ngrx/effects';
import { ActionType } from './store/actions/applications.actions';
import { Observable, of, throwError } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import * as Actions from './store/actions/applications.actions';
import { catchError, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { ApplicationsService } from '../applications/applications.service';

@Injectable({
  providedIn: 'root'
})
export class ApplicationsEffects {

  url = 'https://localhost:44358';

  constructor(
    private actions$: EffectActions,
    private http: HttpClient,
    private applicationsService: ApplicationsService
  ) { }

    // New syntax
    fetchApplicationsByAppIdRequestFirebase$ = createEffect(() => {
      return this.actions$
        .pipe(
          ofType(ActionType.FETCH_APPLICATIONS_BY_APPID),
          mergeMap((action: Actions.FetchApplicationsByAppId) => {

            return this.applicationsService.getApplicationsByAppId$(action.appId)
              .pipe(
                mergeMap((response: any) => {
                  console.log('fetchApplicationsRequestByAppId createEffect syntax...', response);
                  return ([
                    new Actions.FetchApplicationsByAppIdSuccess(response)
                  ]);
                }
                ),
                catchError(err => {
                  console.log('Handling error locally and rethrowing it...', err);
                  return of(new Actions.FetchApplicationsByAppIdFailed(err));
                })

              );
          })
        );
    });

  // @Effect()
  // fetchApplicationsRequest = this.actions$
  //   .pipe(
  //     ofType(ActionType.FETCH_APPLICATIONS),
  //     mergeMap((action: Actions.FetchApplications) => {

  //       const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  //       return this.http.get<Application[]>(this.url + '/api/Applications', httpOptions)
  //         .pipe(
  //           mergeMap((response: any) => {
  //             console.log('fetchApplicationsRequest...', response);
  //             return ([
  //               new Actions.FetchApplicationsSuccess(response)
  //             ]);
  //           }
  //           ),
  //           catchError(err => {
  //             console.log('Handling error locally and rethrowing it...', err);
  //             return of(new Actions.FetchApplicationsFailed(err));
  //           })

  //         );
  //     })
  //   );


  // @Effect()
  // fetchApplicationsByCompanyIdRequest = this.actions$
  //   .pipe(
  //     ofType(ActionType.FETCH_APPLICATIONS_BY_COMPANYID),
  //     mergeMap((action: Actions.FetchApplicationsByCompanyId) => {

  //       const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  //       return this.http.get<Application[]>(this.url + '/api/Applications/GetApplicationsByCompanyId/' + action.companyId, httpOptions)
  //         .pipe(
  //           mergeMap((response: any) => {
  //             console.log('action.companyId...', action.companyId);
  //             console.log('fetchApplicationsByCompanyIdRequest...', response);
  //             return ([
  //               new Actions.FetchApplicationsByCompanyIdSuccess(response)
  //             ])
  //           }
  //           ),
  //           catchError(err => {
  //             console.log('Handling error locally and rethrowing it...', err);
  //             return of(new Actions.FetchApplicationsByCompanyIdFailed(err));
  //           })

  //         )
  //     })
  //   )

  
  fetchApplicationRequestFirebase = createEffect(() => this.actions$
    .pipe(
      ofType(ActionType.FETCH_APPLICATIONS),
      mergeMap((action: Actions.FetchApplications) => {
        return this.applicationsService.getApplications$()
          .pipe(
            mergeMap((response: any) => {
              console.log('fetchApplicationRequest...', response);
              return ([
                new Actions.FetchApplicationsSuccess(response)
              ]);
            }
            ),
            catchError(err => {
              console.log('Handling error locally and rethrowing it...', err);
              return of(new Actions.FetchApplicationsFailed(err));
            })

          );
      })
    ));


  
  fetchApplicationByCompanyIdRequestFirebase = createEffect(() => this.actions$
    .pipe(
      ofType(ActionType.FETCH_APPLICATIONS_BY_COMPANYID),
      mergeMap((action: Actions.FetchApplicationsByCompanyId) => {
        return this.applicationsService.getApplicationsByCompanyId$(action.companyId)
          .pipe(
            mergeMap((response: any) => {
              console.log('fetchApplicationRequestByCompanyId...', response);
              return ([
                new Actions.FetchApplicationsByCompanyIdSuccess(response)
              ]);
            }
            ),
            catchError(err => {
              console.log('Handling error locally and rethrowing it...', err);
              return of(new Actions.FetchApplicationsByCompanyIdFailed(err));
            })

          );
      })
    ));

  
  fetchApplicationByCompanySiteIdIdRequestFirebase = createEffect(() => this.actions$
    .pipe(
      ofType(ActionType.FETCH_APPLICATIONS_BY_COMPANYIDSITEID),
      mergeMap((action: Actions.FetchApplicationsByCompanyIdSiteId) => {

        return this.applicationsService.getApplicationsByCompanyIdSiteId$(action.companyId, action.siteId)
          .pipe(
            mergeMap((response: any) => {
              console.log('fetchApplicationRequestByCompanyIdSiteId...', response);
              return ([
                new Actions.FetchApplicationsByCompanyIdSiteIdSuccess(response)
              ]);
            }
            ),
            catchError(err => {
              console.log('Handling error locally and rethrowing it...', err);
              return of(new Actions.FetchApplicationsByCompanyIdSiteIdFailed(err));
            })

          );
      })
    ));

  // @Effect()
  // addApplication = this.actions$
  //   .pipe(
  //     ofType(ActionType.ADD_APPLICATION),
  //     mergeMap((action: Actions.AddApplication) => {

  //       const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  //       let applications = action.application;
  //       applications = { ...applications }

  //       return this.http.post<Application>(this.url + '/api/Applications/', applications, httpOptions)
  //         .pipe(
  //           mergeMap((response: any) => {
  //             console.log('response...', response);
  //             return ([
  //               new Actions.AddApplicationSuccess(response)
  //             ])
  //           }
  //           ),
  //           catchError(err => {
  //             console.log('Handling error locally and rethrowing it...', err);
  //             return of(new Actions.AddApplicationFailed());
  //           })

  //         )
  //     })
  //   )

  
  addApplicationFirebase = createEffect(() => this.actions$
    .pipe(
      ofType(ActionType.ADD_APPLICATION),
      mergeMap(async (action: Actions.AddApplication) => {

        const application = action.application;

        await this.applicationsService.addApplicationFirebase$(application)
          .then((response) => {
            application.id = response.id;
            console.log('application...', application);
          }).catch((err) => {
            // application.id! = null;
            console.log('err in catch...', err);
          });

        if (application.id !== null) {
          return new Actions.AddApplicationSuccess(application);
        } else {
          return new Actions.AddApplicationFailed();
        }
      })
    ));


  
  deleteApplication = createEffect(() => this.actions$
    .pipe(
      ofType(ActionType.DELETE_APPLICATION),
      mergeMap((action: Actions.DeleteApplication) => {
        const id = action.id;
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

        return this.http.delete<number>(this.url + '/api/Applications/' + id, httpOptions)
          .pipe(
            mergeMap((response: any) => {
              console.log('response...', response);
              return ([
                new Actions.DeleteApplicationSuccess(response.id)
              ]);
            }
            ),
            catchError(err => {
              console.log('Handling error locally and rethrowing it...', err);
              return of(new Actions.DeleteApplicationFailed());
            })

          );
      })
    ));


  
  destroyApplicationFirebase = createEffect(() => this.actions$
    .pipe(
      ofType(ActionType.DESTROY_APPLICATION),
      mergeMap(async (action: Actions.DestroyApplication) => {

        const id = action.id;

        await this.applicationsService.destroyApplicationFirebase$(id)
          .then((response) => {
            console.log('response...', response);
          }).catch((err) => {
            console.log('err in catch...', err);
          });

        if (id !== null) {
          return new Actions.DestroyApplicationSuccess(id);
        } else {
          return new Actions.DestroyApplicationFailed();
        }
      })
    ));



  // @Effect()
  // destroyApplication = this.actions$
  //   .pipe(
  //     ofType(ActionType.DESTROY_APPLICATION),
  //     mergeMap((action: Actions.DestroyApplication) => {
  //       const id = action.id
  //       const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  //       return this.http.delete<number>(this.url + '/api/Applications/' + id, httpOptions)
  //         .pipe(
  //           mergeMap((response: any) => {
  //             console.log('response...', response);
  //             return ([
  //               new Actions.DestroyApplicationSuccess(response.id)
  //             ])
  //           }
  //           ),
  //           catchError(err => {
  //             console.log('Handling error locally and rethrowing it...', err);
  //             return of(new Actions.DestroyApplicationFailed());
  //           })

  //         )
  //     })
  //   )

  // @Effect()
  // updateApplication = this.actions$
  //   .pipe(
  //     ofType(ActionType.UPDATE_APPLICATION),
  //     mergeMap((action: Actions.UpdateApplication) => {

  //       const message = action.application;
  //       const id = action.application.id;
  //       const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  //       let Application = action.application

  //       return this.http.put<Application>(this.url + '/api/Applications/' + id, Application, httpOptions)
  //         .pipe(
  //           mergeMap((response: any) => {

  //             console.log('response updateApplication...', Application);
  //             return ([
  //               new Actions.UpdateApplicationSuccess(Application)
  //             ])
  //           }
  //           ),
  //           catchError(err => {
  //             console.log('Handling error locally and rethrowing it...', err);
  //             return of(new Actions.UpdateApplicationFailed());
  //           })

  //         )
  //     })
  //   )

  
  updateApplicationFirebase = createEffect(() => this.actions$
    .pipe(
      ofType(ActionType.UPDATE_APPLICATION),
      mergeMap((action: Actions.UpdateApplication) => {

        const application = action.application;

        return this.applicationsService.updateApplicationFirebase$(application)
          .pipe(
            mergeMap((response: any) => {

              console.log('response updateApplicationFirebase...', application);
              return ([
                new Actions.UpdateApplicationSuccess(application.id!, application)
              ]);
            }
            ),
            catchError(err => {
              console.log('Handling error locally and rethrowing it...', err);
              return of(new Actions.UpdateApplicationFailed());
            })

          );
      })
    ));
}
